import axiosapi from "./axiosAPI";

// Get All MaritalStatus
export const getAllMaritalStatuses = async (
    setMaritalStatuses,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/maritalStatus");
        setMaritalStatuses(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MaritalStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MaritalStatus");
		}
		
	}
	
};



// Get One MaritalStatus
export const getOneMaritalStatus = async (
    pkid,
    setFetcherror,  
    setMaritalStatus
    
)=>{
	try{
		const res =await axiosapi.get(`/maritalStatus/${pkid}`);
        setMaritalStatus(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MaritalStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MaritalStatus");
		}
		
	}
	
};


// Create New MaritalStatus
export const createMaritalStatus = async (
    maritalStatus,
    setMaritalStatus,
    setFetcherror,
    handleAllToasts,
    setMaritalStatuses

) => {

    if (!maritalStatus ) {
        handleAllToasts(2, "No MaritalStatus Provided"); 
            return; 
        }

    const PushItem = {
            name: maritalStatus,
        };

    try{
        await axiosapi.post("/maritalStatus/",PushItem );
        setMaritalStatus("");
        handleAllToasts(1, "MaritalStatus Created Successfully");
        getAllMaritalStatuses(setMaritalStatuses,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New MaritalStatus");
            handleAllToasts(2, "Could Not update The MaritalStatus");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New MaritalStatus");
            handleAllToasts(2, "Could Not update The MaritalStatus");
            
        }
        
    }
    
}


// Edit Existing MaritalStatus

export const editMaritalStatus = async (
    maritalStatuspkid,
    maritalStatus,
    setMaritalStatus,
    setFetcherror,
    handleAllToasts,
    setMaritalStatuses
              
        ) => {

            if (!maritalStatus) {
                handleAllToasts(2, "No MaritalStatus Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:maritalStatuspkid,
                    name: maritalStatus,
                };

            try{
                await axiosapi.patch("/maritalStatus/",PushItem );
                setMaritalStatus("");
                handleAllToasts(1, "MaritalStatus Updated Successfully");
                getAllMaritalStatuses(setMaritalStatuses,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update MaritalStatus");
                    handleAllToasts(2, "Could Not Update MaritalStatus");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update MaritalStatus");
                    handleAllToasts(2, "Could Not Update MaritalStatus");
                    
                }
                
            }
            
};



// Delete Existing MaritalStatus.

export const deleteMaritalStatus = async (
    maritalStatuspkid,
    setMaritalStatuses,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/maritalStatus/${maritalStatuspkid}`);
        let finalData = res.data.message;
        getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
        handleAllToasts(1, "MaritalStatus Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete MaritalStatus");
            handleAllToasts(2,"Error: Could Not Delete MaritalStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete MaritalStatus");
            handleAllToasts(2,"Error: Could Not Delete MaritalStatus");
		}
		
	}
	
};